const { removeSpecialChar } = require("@starberry/gatsby-library-common/BasicUtils")

//format URL using the search filters form values
export const createResultsUrl = (props) => {
    //lets form the URL

    let searchtypePath = ""
    let areaPath = ""
    let bedPath = ""
    let pricePath = ""
    let buildingPath = ""
    let sortPath = ""
    let layoutPath = ""

    if (props?.search_type === "buy") {
        searchtypePath = "for-sale/"
    } else if (props?.search_type === "rent") {
        searchtypePath = "to-rent/"
    } else {
        searchtypePath = "new-homes/for-sale/"
    }
    if (props?.area) {
        // first trim the value for start and end empty spaces; remove one more '-'
        // let areafilt = (props?.area).trim();
        // areafilt = areafilt.replace(/-+/gi,'-')
        // //remove special char except , and space
        // areafilt = areafilt.replace(/[^-,a-zA-Z ]/g, '');
        // // split using comma
        // areafilt = areafilt.split(",");
        // let areafiltUpd = areafilt.map(area => {
        //     if (area.charAt(0) == '-') {
        //         area = area.substring(1);
        //     }
        //     if (area.charAt((area.length)-1) == '-') {
        //         area = area.substring(0,area.length-1);
        //     }
        //     return area;
        // })
        // // again trim the values & join using -and- & replace multiple space
        // areaPath = "in-" + encodeURIComponent(decodeURIComponent(areafiltUpd.join("-and-"))) + "/"
        areaPath = "in-" + encodeURIComponent(decodeURIComponent(removeSpecialChar(props?.area))) + "/"
    } else {
        areaPath = `in-${(process.env.GATSBY_DEFAULT_AREA).toLowerCase()}/`;
    }
    if (props?.bedrooms) {
        if (parseInt(props?.bedrooms) === 0) {
            bedPath = "studio/"
        }

        if (parseInt(props?.bedrooms) > 0) {
            bedPath = props?.bedrooms + "-and-more-bedrooms/"
        }
    }
    if ( props?.min_price || props?.max_price ) {
        if (props?.min_price&& props?.max_price) {
            pricePath = "between-" + props?.min_price + "-and-" + props?.max_price + '/';
        } else if (props?.max_price) {
            pricePath = "below-" + props?.max_price + '/';
        } else if (props?.min_price) {
            pricePath = "above-" + props?.min_price + '/';
        }
    }
    if (props?.building_type) {
        buildingPath = "type-" + props?.building_type.replace(/ /g, '-') + "/"
    }
    if (props?.sortby) {
        if (props?.sortby === process.env.GATSBY_ALGOLIA_INDEX_NAME + "_price_asc") {
            sortPath = "sortby-price-asc/";
        }
        if (props?.sortby === process.env.GATSBY_ALGOLIA_INDEX_NAME + "_price_desc") {
            sortPath = "sortby-price-desc/";
        }
    }
    if (props?.layout) {
        layoutPath = "map-view/";
    }
    let myUrl = `/property/${searchtypePath}${areaPath}${bedPath}${pricePath}${buildingPath}${sortPath}${layoutPath}`;

    myUrl = myUrl.toLowerCase().replace(/ /g, '-');

    return myUrl;//navigate(myUrl)
}


export const parseResultsUrl = (location, base_path, search_type, department_type, property_status, index_name_val) => {
    //split the URL
    if (location) {
        var pathUri_main = ""
        let departmentVal = ["residential","new_developments"]
        let searchtypeVal = ""
        let areaVal = "london"
        let bedVal = ""
        let bedValPlus = "false"
        let minpriceVal = ""
        let maxpriceVal = ""
        let pageVal = "1"
        let buildingval = ""
        let sortVal = ""
        let layoutVal = ""
        let index_name = index_name_val || process.env.GATSBY_ALGOLIA_INDEX_NAME
        let propertyTypeVal = "residential"
        let mustincludeVal = ""
        let furnishVal = ""
        let branchVal = ""
        let radiusVal = ""
        let minfloorVal = ''
        let maxfloorVal = ''
        let statusVal = ''

        let salespage  = location.pathname.indexOf("/property/for-sale") > -1
        let lettingspage = location.pathname.indexOf("/property/to-rent") > -1
        let newdevelopmentspage = location.pathname.indexOf("/property/new-homes/for-sale") > -1
        let new_developments = location.pathname.indexOf("/new-developments/for-sale") > -1
        let commercial_sale_page = location.pathname.indexOf("/property/commercial/for-sale") > -1
        let commercial_rent_page = location.pathname.indexOf("/property/commercial/to-rent") > -1

        if(base_path){
            pathUri_main = location.pathname.split(base_path)
            searchtypeVal = search_type
            departmentVal = department_type

        } else{

            if (salespage === true) {
                pathUri_main = location.pathname.split("/property/for-sale")
                searchtypeVal = "sales"
            }
            else if (lettingspage === true) {
                pathUri_main = location.pathname.split("/property/to-rent")
                searchtypeVal = "lettings"
            }
            else if (newdevelopmentspage === true) {
                pathUri_main = location.pathname.split("/property/new-homes/for-sale")
                searchtypeVal = "sales"
                departmentVal = "new_developments"
            } 
            else if (commercial_sale_page === true) {
                pathUri_main = location.pathname.split("/property/commercial/for-sale")
                searchtypeVal = "sales"
                departmentVal = "commercial"
            } 
            else if (commercial_rent_page === true) {
                pathUri_main = location.pathname.split("/property/commercial/to-rent")
                searchtypeVal = "lettings"
                departmentVal = "commercial"
            }
        }

        if (pathUri_main[1]) {
            // following could be regexp
            let pathUri = pathUri_main[1].split("/")

            // console.log("pathUri_main", pathUri)

            //lets loop
            for (let vi = 0; vi <= pathUri.length; vi++) {
                // check for area
                if (typeof pathUri[vi] === "undefined") {
                    continue
                }

                //console.log("pathUri_main", pathUri[vi], pathUri[vi].indexOf("in-"))

                // Area
                if(pathUri[vi].indexOf("chain-free") >= 0){

                } else{
                    if (pathUri[vi].indexOf("in-") >= 0) {
                        areaVal = removeSpecialChar(pathUri[vi].replace("in-", ""), " ")
                    }
                }

                // Bedrooms
                if (pathUri[vi].indexOf("-bedrooms") >= 0) {
                    bedVal = pathUri[vi].replace("-bedrooms", "")
                    bedValPlus = "false"
                }

                if (pathUri[vi].indexOf("-and-more-bedrooms") >= 0) {
                    bedVal = pathUri[vi].replace("-and-more-bedrooms", "")
                    bedValPlus = "true"
                }

                // Property type
                if (pathUri[vi].indexOf("type-") >= 0) {
                    buildingval = pathUri[vi].replace("type-", "")
                }

                // Price
                if (
                pathUri[vi].indexOf("between-") >= 0 ||
                pathUri[vi].indexOf("above-") >= 0 ||
                pathUri[vi].indexOf("below-") >= 0 || 
                pathUri[vi].indexOf("under-") >= 0 || 
                pathUri[vi].indexOf("over-") >= 0
                ) {
                    let priceFilt1 = pathUri[vi].split("above-")
                    if (priceFilt1[1]) {
                        minpriceVal = priceFilt1[1]
                    }
                    let priceFilt2 = pathUri[vi].split("below-")
                    if (priceFilt2[1]) {
                        maxpriceVal = priceFilt2[1]
                    }
                    let priceFilt3 = pathUri[vi].split("between-")
                    if (priceFilt3[1]) {
                        let priceFilt4 = priceFilt3[1].split("-and-")
                        minpriceVal = priceFilt4[0]
                        maxpriceVal = priceFilt4[1]
                    }
                    let priceFilt4 = pathUri[vi].split("over-")
                    if (priceFilt4[1]) {
                        minpriceVal = priceFilt4[1]
                    }
                    let priceFilt5 = pathUri[vi].split("under-")
                    if (priceFilt5[1]) {
                        maxpriceVal = priceFilt5[1]
                    }
                }

                // Sort by
                if (pathUri[vi].indexOf("sortby-") >= 0) {
                    let sortVal_filt = pathUri[vi].replace("sortby-", "")

                    if (sortVal_filt === "") {
                        sortVal = index_name;
                    }

                    if (sortVal_filt === "price-asc") {
                        sortVal = index_name + "_price_asc"
                    }

                    if (sortVal_filt === "price-desc") {
                        sortVal = index_name + "_price_desc"
                    }

                    if (sortVal_filt === "most-recent") {
                        sortVal = index_name + "_most_recent"
                    }

                    if (sortVal_filt === "oldest") {
                        sortVal = index_name + "_oldest"
                    }
                }

                // Page
                if (pathUri[vi].indexOf("page") >= 0) {
                    pageVal = pathUri[vi].replace("page-", "")
                }

                if (pathUri[vi].indexOf("map-view") >= 0) {
                    layoutVal = "map"
                }

                // Mustinclude
                if (pathUri[vi].indexOf("with-") >= 0) {
                    //mustincludeVal = pathUri[vi].replace("with-", "")
                    var mustincludeArrfilt = pathUri[vi].replace("with-", "")
                    mustincludeVal = mustincludeArrfilt.split("-and-")
                }

                // Furnishing Val
                if (pathUri[vi].indexOf("furnishing-") >= 0) {
                    furnishVal = pathUri[vi].replace("furnishing-", "")
                }

                // Branch Val
                if (pathUri[vi].indexOf("branch-") >= 0) {
                    branchVal = pathUri[vi].replace("branch-", "")
                }


                // Radius Val
                if (pathUri[vi].indexOf("radius-") >= 0) {
                    radiusVal = pathUri[vi].replace("radius-", "").replace("-miles", "")
                }

                // Sqft
                if ( pathUri[vi].indexOf("sqft-") >= 0 || 
                    pathUri[vi].indexOf("minsqft-") >= 0 || 
                    pathUri[vi].indexOf("maxsqft-") >= 0
                ) {
                    // its floor
                    let floorFilt1 = pathUri[vi].split('minsqft-');
                    if( floorFilt1[1] ) {
                        minfloorVal = floorFilt1[1]
                    }
                    let floorFilt2 = pathUri[vi].split('maxsqft-');
                    if( floorFilt2[1] ) {
                        maxfloorVal = floorFilt2[1]
                    }
                    let floorFilt3 = pathUri[vi].split('sqft-');
                    if( floorFilt3[1] ) {
                        let floorFilt4 = floorFilt3[1].split('-and-');
                        minfloorVal = floorFilt4[0]
                        maxfloorVal = floorFilt4[1]
                    }
                }

                if (pathUri[vi].indexOf("available") >= 0) {
                    // its studio bedroom

                    if(searchtypeVal === "sales"){
                        statusVal = "For Sale"
                    } else{
                        statusVal = "To Let"
                    }
                }

            }
        }
        var mydatarr = []
        mydatarr['indexVal'] = index_name
        mydatarr['departmentVal'] = departmentVal
        mydatarr['searchtypeVal'] = searchtypeVal
        mydatarr['areaVal'] = areaVal
        mydatarr['bedVal'] = bedVal
        mydatarr['bedValPlus'] = bedValPlus
        mydatarr['minpriceVal'] = minpriceVal
        mydatarr['maxpriceVal'] = maxpriceVal
        mydatarr['pageVal'] = pageVal
        mydatarr['buildingval'] = buildingval
        mydatarr['sortVal'] = sortVal
        mydatarr['layoutVal'] = layoutVal
        mydatarr['propertyTypeVal'] = propertyTypeVal
        mydatarr['mustincludeVal'] = mustincludeVal
        mydatarr['furnishVal'] = furnishVal
        mydatarr['branchVal'] = branchVal
        mydatarr['radiusVal'] = radiusVal
        mydatarr['minfloorVal'] = minfloorVal
        mydatarr['maxfloorVal'] = maxfloorVal
        mydatarr['statusVal'] = statusVal
        return mydatarr
    }
    return false
}

export const generateFiltersfromPageData = (departmentVal,searchtypeVal,areaVal,bedVal,bedValPlus,minpriceVal,maxpriceVal,buildingval, mustincludeVal, furnishVal, branchVal, minfloorVal, maxfloorVal) => {
    // lets from the filters 
    // here the search login lives
    var myfilter = []
    //facet filters
    if(departmentVal){
        if(buildingval=="new-home"){
            myfilter.push("(department:new_developments)")
        } else if(Array.isArray(departmentVal)) {
            myfilter.push('(department:'+(departmentVal).join(' OR department:')+')')
        } else {
            myfilter.push("(department:"+departmentVal+")")
        }
    }
    if(searchtypeVal){
        myfilter.push("(search_type:"+searchtypeVal+") OR (searchType:"+searchtypeVal+")")
    }
    // if(areaVal && areaVal !== "london"){
    //     myfilter.push("(area:"+areaVal+" OR post_code:"+areaVal+" OR display_address:"+areaVal+")")
    // }


    let building_val = ["house", "semi-detached-house", "detached-house"]
    if(buildingval && buildingval!="new-home"){
        if(buildingval === "house"){
            myfilter.push('(building:'+(building_val).join(' OR building:')+')')
        } else{
            myfilter.push("(building:"+buildingval+")")
        }
    }



    // if(buildingval && buildingval!="new-home"){
    //     myfilter.push("(building:"+buildingval+")")
    // }
    //numberic filters
    //console.log("bedValPlus ==>", bedValPlus);

    if(bedValPlus === "true"){
        if(bedVal && bedVal > 0){
            myfilter.push("(bedroom >= "+bedVal+")")
        }
    } else{
        if(bedVal && bedVal > 0){
            myfilter.push("(bedroom = "+bedVal+")")
        }
    }
    if( (minpriceVal && minpriceVal > 0) && (maxpriceVal && maxpriceVal > 0) ){
        myfilter.push("(price >= "+minpriceVal+" AND price <= "+maxpriceVal+")")
    } else if(maxpriceVal && maxpriceVal > 0) {
        myfilter.push("(price <= "+maxpriceVal+")")
    } else if(minpriceVal && minpriceVal > 0) {
        myfilter.push("(price >= "+minpriceVal+")")
    }

    if( (minfloorVal && minfloorVal > 0) && (maxfloorVal && maxfloorVal > 0) ){
        myfilter.push("(floorarea_min >= "+minfloorVal+" AND floorarea_min <= "+maxfloorVal+")")
    } else if(maxfloorVal && maxfloorVal > 0) {
        myfilter.push("(floorarea_min <= "+maxfloorVal+")")
    } else if(minfloorVal && minfloorVal > 0) {
        myfilter.push("(floorarea_min >= "+minfloorVal+")")
    }
    // if(pageVal){
    //     myfilter.push("(page: "+(pageVal)+")")
    // }
    myfilter.push("(publish: true)")

    console.log("mustincludeVal", mustincludeVal);

    // Mustinclude
    if (mustincludeVal?.length > 0) {
        //query += `&refinementList[mustInclude]=` + mustincludeVal
        let must_include_arr = "";

        must_include_arr = '(must_include:"'+(mustincludeVal).join('" OR must_include:"')+'")'

        myfilter.push(must_include_arr)

        // for (let v = 0; v <= mustincludeVal.length; v++) {
        //     if (typeof mustincludeVal[v] !== "undefined") {
        //         myfilter.push("(must_include:"+mustincludeVal[v]+")")
        //         must_include_arr = '(must_include:"'+(mustincludeVal).join('" OR must_include:"')+'")'
        //     }
        // }
    }

    if(furnishVal){
        myfilter.push("(furnishing:"+furnishVal+")")
    }
    
    if(branchVal){
        myfilter.push("(office_crm_id:"+branchVal+")")
    }

    return myfilter.join(' AND ')
}
